export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f75292479f03ac6b158b0d3591a5c4823fb245e14&name=fetchTypeahead!'